import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { BlogPost, CurrentUser } from 'types';
import { subscribeToBlogPostActivity } from 'api';
import { Button } from 'components/Button';
import { SnackbarProps } from 'components/Snackbar';
import { DynamicInput } from 'components/Inputs';
import { getDataFromLocalStore, setDataToLocalStore } from 'utils/localStoreTools';

import styles from './BlogPage.module.scss';

export type SubscribeBlockProps = {
  blogPost: BlogPost;
  isAuthenticated: boolean;
  setSubscribed: Dispatch<SetStateAction<boolean>>;
  setSnackbarMessage: Dispatch<SetStateAction<SnackbarProps | null>>;
  user: CurrentUser | null | undefined;
};

export const SubscribeBlock = ({
  blogPost,
  isAuthenticated,
  setSnackbarMessage,
  setSubscribed,
  user,
}: SubscribeBlockProps) => {
  const [email, setEmail] = useState<string>('');
  const [subscriptions, setSubscriptions] = useState<string[]>([]);

  useEffect(() => {
    setSubscriptions(getDataFromLocalStore('subscribedToNewsletter'));
  }, []);

  const subscriptionEmail = !isAuthenticated ? email : user?.email || '';
  const blogPostActivities = blogPost.activities.map(activity => activity.slug);

  const handleSubscribe = async () => {
    const res = await subscribeToBlogPostActivity(subscriptionEmail, blogPost.slug);

    if (res.status === 204) {
      setSnackbarMessage({ header: 'You are subscribed successfully' });

      if (isAuthenticated) {
        setDataToLocalStore(
          'subscribedToNewsletter',
          subscriptions?.length > 0 ? [...subscriptions, ...blogPostActivities] : blogPostActivities,
        );
        setSubscribed(true);
      }
    } else {
      setSnackbarMessage({
        mode: 'error',
        header: res.message || 'Sorry, server responds with error. Please, try later',
      });
    }
  };

  const onEmailChange = (fieldName: string = 'email', value: any) => {
    setEmail(value);
  };

  return (
    <>
      <div className={styles.subscribeBlock}>
        <div className={styles.content}>
          <h4 className={styles.subscribeHeading}>Don&apos;t want to miss anything?</h4>
          <p className={styles.subscribeDescription}>
            Get weekly updates on the newest gear stories, sports and tips right in your mailbox.
          </p>

          <div className={styles.emailForm}>
            {!isAuthenticated && (
              <div className={styles.subscribeInput}>
                <DynamicInput
                  type="email"
                  id="email"
                  placeholder="Email"
                  fieldName="email"
                  value={email}
                  onChange={onEmailChange}
                  isThin={true}
                />
              </div>
            )}

            <div className={styles.subscribeBtn}>
              <Button buttonType="blue" caption="Subscribe" action={handleSubscribe} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
